"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyUnavailablePage = void 0;
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
// This page is shown when a survey participant tries to access a survey that is no longer available (frozen by an admin)
const SurveyUnavailablePage = () => {
    const { t } = (0, react_i18next_1.useTranslation)(['main']);
    return (react_1.default.createElement("div", { className: "survey", id: "surveyUnavailablePage" },
        react_1.default.createElement("div", { className: "apptr__form" },
            react_1.default.createElement("div", { className: "survey-page-container" },
                react_1.default.createElement("h2", { className: "survey-page-title" }, t('main:SurveyUnavailableTitle')),
                react_1.default.createElement("p", null, t('main:SurveyUnavailableDefaultReason')),
                react_1.default.createElement("img", { src: "dist/images/page_images/undraw_access-denied_krem.svg", alt: t('main:SurveyUnavailableTitle'), className: "survey-page-image" })))));
};
exports.SurveyUnavailablePage = SurveyUnavailablePage;
exports.default = exports.SurveyUnavailablePage;
//# sourceMappingURL=SurveyUnavailablePage.js.map